import React, { Component } from 'react';
import EnhancedMomDiary from './EnhancedMomDiary'
import { Redirect } from 'react-router-dom'
class MomDiaryRecord extends Component {

  state = {
    redirect: false
  }

  goBack = () => {
    this.setState({
      redirect: true
    })
  }


  render() {

    if(this.state.redirect == true) {
      return <Redirect to="/personalhealthrecord/momdiary" />
    }

    return (
      <EnhancedMomDiary goBack={this.goBack}/>
    )
  }
}

export default MomDiaryRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/MomDiary/MomDiaryRecord.js